/* ChartContainer auto-generated by npm run generator */
import { makeStyles, Theme, Typography } from "@material-ui/core"
import { observer } from "mobx-react"
import React from "react"

interface ChartContainerProps {
    children?: React.ReactNode
    title: string
}

const useStyles = makeStyles((theme: Theme) => ({
    chartContainerAtom: {
        overflowX: "hidden",
    },
    charts: {
        overflowX: "scroll",
        padding: theme.spacing(4, 4, 4, 1),
        display: "grid",
        gridGap: theme.spacing(4),
        gridAutoFlow: "column",
        "&::after": {
            content: "''",
            width: theme.spacing(2),
        },
    },
}))

const ChartContainer: React.FC<ChartContainerProps> = (props) => {
    const classes = useStyles()
    return (
        <div className={classes.chartContainerAtom}>
            <Typography variant="h5">{props.title}</Typography>
            <div className={classes.charts}>{props.children}</div>
        </div>
    )
}

export default observer(ChartContainer)
